export default {
  myAccount: {
    headings: {
      yourAccount: 'Your Account',
      legal: 'Legal',
    },
    accordions: {
      transactionHistory: 'Transaction History',
      accountSettings: 'Account Settings',
      loginSettings: 'Login Settings',
      notifications: 'Notifications',
      responsibleGaming: 'Responsible Gaming',
      faq: 'FAQ',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      taxInformation: 'Tax Information',
    },
    buttons: {
      withdraw: 'Withdraw',
      deposit: 'Deposit',
      myProfile: 'My Profile',
      contactSupport: 'Contact Support',
      signOut: 'Sign Out',
    },
    limits: {
      title: 'User Limits',
      depositLimit: 'Deposit Limit',
      depositLimitCopy:
        'Set deposit limits to restrict the amount you can deposit into your account for each timeframe.',
      entryFeeLimit: 'Entry Fee Limit',
      entryFeeLimitCopy: 'Set limits on the amount you can use on entry fees for each timeframe.',
      contestEntryLimit: 'Contest Entry Limit',
      contestEntryLimitCopy:
        'Set limits on the amount of contest you can enter for each timeframe.',
      loading: 'Fetching Limits...',
      applyLimits: 'Apply Limits',
      conformLimits: 'Confirm Limits',
      missingField: {
        title: 'Missing Field',
        amount: 'Please select your amount',
      },
      successSetLimits: {
        title: 'Limits Set Successfully!',
        message: 'Congratulations, you set your responsible gaming limits.',
      },
      errorSetLimits: {
        title: 'Limits Not Set Successfully',
        defaultMessage:
          'Unfortunately, we could not set your responsible gaming limits. Please contact customer support.',
      },
      weekly: 'Weekly',
      monthly: 'Monthly',
      limit: 'Limit',
      amount: 'Amount ($)',
      limitNote:
        'Once applied, you will not be able to edit or remove your limit until the 90 day period has ended.',
      activePanel: {
        title: 'Active Limit',
        // eslint-disable-next-line no-template-curly-in-string
        current: '<strong>${{amount}}</strong> per {{period}}. Expires {{expiresAt}}',
        // eslint-disable-next-line no-template-curly-in-string
        remaning: '(${{remaining}} remaining)',
      },
    },
    editAccount: {
      editLink: 'Edit Information',
      editAvatar: 'Edit Avatar',
      title: 'EDIT INFORMATION',
      notVerified: {
        title: "You're not verified!",
        message: 'You must verify your identity to play real money games on Splash.',
        cta: 'Learn more',
        verify: 'Verify',
        status: 'Not Verified',
      },
      verified: {
        title: 'You are verified!',
        message: 'Need to update your information?',
        cta: 'Contact support',
        verify: 'Verify',
        status: 'Verified',
      },
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        handle: 'Handle',
        buttonLabel: 'Save',
        errors: {
          firstName: 'First name is required',
          lastName: 'Last name is required',
          handle: 'Handle is required',
          email: 'Please enter a valid email address',
        },
      },
      notifications: {
        success: {
          title: 'Account Updated',
          message: 'Your account has been updated successfully',
        },
        error: {
          title: 'Update Failed',
          message: 'There was an error updating your account',
        },
      },
    },
    loginAndSettings: {
      accordionLabel: 'Login and Account Settings',
      accordionDescription: 'Manage your account settings',
      resetPassword: 'Reset Password',
      deactivateAccount: 'Deactivate Account',
      rypLinked: 'RYP Account linked',
      ofpLinked: 'OFP Account linked',
      rypSubtitle: 'Your Splash account is linked to your RYP account.',
      accountDeactivation: {
        title: 'Account Deactivation',
        copy1:
          'Deactivating your Splash account will temporarily close your account. You will no longer be able to log in and you will not receive communications from us.',
        copy2: 'You may reach out to customer support at any time to reactivate your account.',
        confirm: 'Deactivate Account',
        cancel: 'Go Back',
        confirmTitle: 'Deactivate Account Confirmation',
        confirmDescription:
          'Deactivating your Splash account will temporarily close your account and log you out. You will no longer be able to log in and you will not receive communications from us.',
        confirmYes: 'Yes, deactivate',
        confirmCancel: 'Go back',
      },
    },
    timeouts: {
      title: 'Timeout',
      subtitle: 'Select your timeout length',
      description:
        'If you wish to disable your account for any reason, you can do so for up to 5 years. Your account will automatically become active once your timeout ends.',
      note: 'Once confirmed, we will log you out and you will not be able to access your account until the timeout period is complete.',
      placeholder: 'Timeout length',
      label: 'No Timeout Set',
      cta: 'Set Timeout',
      close: 'Close',
      exclusionPartners: {
        checkboxLabel: 'Share my self exclusion with participating operators',
        description:
          'Splash Sports has partnered with IDPair to securely share your self exclusion, providing an easy way to self exclude across participating operators.',
        learnMore: 'Learn more',
        learnMoreDescription:
          'Your self-exclusion will be shared with participating apps, helping you take a complete break without needing to set exclusions on each one individually. Participating Operators:',
      },
      confirm: {
        title: 'Confirm timeout?',
        description:
          'By confirming a timeout on your account, you will not have access to your account until {{endDate}}.',
        confirmLabel: 'Confirm Timeout',
        cancelLabel: 'Go Back',
      },
      error: {
        title: 'Timeout Not Set Successfully!',
        message: 'Unfortunately, we could not set your timeout. Please contact customer support.',
        supportSubject: 'Timeout',
        supportBody: 'Hello, Splash. Please help me set my Responsible Gaming limits.',
      },
    },
    responsibleGaming: {
      accordionLabel: 'Responsible Gaming',
      buttons: {
        timeout: 'Timeout',
        userLimits: 'User Limits',
        responsibleGamingInfo: 'Responsible Gaming Info',
      },
      label: 'Responsible Gaming Info',
      cta: 'Learn More',
      accordionDescription: 'Set your limits and learn more about responsible gaming',
    },
    communications: {
      accordionLabel: 'Communication Settings',
      accordionDescription: 'Manage your communication settings',
      panelLabel: 'For the account registered to {{email}}',
      panelDescription:
        'If you wish to stop receiving notifications for any of the topics below, simply uncheck the relevant box.',
      columns: {
        email: 'Email',
        push: 'Push',
        inApp: 'In-app',
      },
      categoryColumnLabel: 'Notification',
      channelAriaLabel: '{{channel}} notifications for {{name}}',
      channelUnavailableAriaLabel: '{{channel}} notifications are not available for {{name}}',
      splashNewsletterLabel: 'Marketing Communications',
      splashNewsletterDescription:
        'If this box is checked, you will receive communications from our marketing team.',
      preferences: {
        updated: {
          title: 'Preference Updated',
        },
        enabledNotification: 'You will now receive {{type}} notifications for {{name}}.',
        disabledNotification: 'You will no longer receive {{type}} notifications for {{name}}.',
      },
    },
    taxInformation: {
      title: 'Tax Information',
      myDocumentsTitle: 'My Tax Documents',
      providedCopy:
        "You've successfully provided your tax information. We'll use the information you provided to automatically complete your W-9 Tax Form each year.",
      requiredCopy:
        "To comply with the US federal regulations, you're required to fill out a W-9 form. For more info, contact support or read our terms of use.",
      completedCopy: "You've completed the following tax documents:",
      notCompletedCopy: "You haven't completed any tax documents.",
      buttons: {
        updateTaxInformation: 'Update My Tax information',
        startTaxForm: 'Start Tax Form',
      },
      stepTitles: {
        step1: 'Please complete W-9 Tax Form',
        step2: 'Taxpayer Identification Form',
        step3: 'W-9 Submitted',
      },
    },
    transactionHistory: {
      title: 'Transaction History',
      titleMarkets: 'Splash Player Reserve Transaction History',
      description: 'View your transaction history',
      pendingTitle: 'Pending transactions',
      recentTitle: 'Recent transactions',
      allTransactions: 'All transactions',
      noTransactions: 'No transactions',
      noTransactionsNote: 'Try selecting a different month.',
      columns: {
        type: 'Type',
        id: 'Transaction ID',
        date: 'Date',
        balance: 'Balance',
        amount: 'Amount',
      },
      statement: {
        download: 'Download statement',
        pending: 'Statement will be generated at the end of month.',
        downloadError: 'There was an error downloading your statement',
        openError: 'Unable to open the statement. Allow pop-ups and try again.',
      },
      transactionDetails: {
        type: 'Type',
        paymentType: 'Payment Type',
        dateTime: 'Date/Time',
        previousBalance: 'Previous Balance',
        amount: 'Amount',
        balance: 'Balance',
        id: 'ID',
      },
      filters: {
        all: 'All',
        markets: 'Predict',
      },
      marketDetails: {
        dateTime: 'Date and Time:',
        amount: 'Amount:',
        contracts: 'Contracts:',
        contractPrice: 'Contract Price:',
        fees: 'Fees:',
        market: 'Market:',
        orderId: 'Order ID:',
        settlement: 'Settlement:',
        settlementId: 'Settlement ID:',
        inTheMoney: 'In the money',
        outOfTheMoney: 'Out of the money',
      },
    },
  },
  balanceWidget: {
    cash: 'Cash',
    cashTooltip: 'Your total cash balance including withdrawable funds and playthrough cash.',
    withdrawableBalance: 'Withdrawable balance',
    withdrawableAmount: 'Withdrawable: {{amount}}',
    credits: 'Credits',
    refundableBalance: 'Refundable balance',
    withdrawTooltip:
      'The amount available to cash out. Excludes Splash credits, play through cash, and funds eligible for refund.',
    creditsTooltip: 'Non-withdrawable funds provided by Splash Sports for gameplay only.',
    refundableTooltip:
      'Funds that were deposited and not played through. Must be withdrawn to the same payment method that was used for the deposit.',
    playthroughExplanation:
      'Since you claimed a deposit bonus <bold>{{amount}} of your balance must be played through</bold> and can only be used for contest entry. All winnings will be eligible for withdrawal.',
    withdraw: 'Withdraw',
    deposit: 'Deposit',
  },
};
